import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { faCircleInfo, faGrid2 } from "@fortawesome/pro-regular-svg-icons";

import { useAuth } from "~/providers/store/auth";
import { Footer } from "~/components/Footer";
import { Button, DialogLoading, LayoutLogo } from "~/components";
import { useCurrentSession } from "~/api/sessions/hooks/use-session";
import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { T } from "@repo/transifex";
import { getSellRouteForTill } from "~/utils/tills/is-unattended-till";

export const SettingsPage = () => {
  const { status } = useAuth();
  const { data: till } = useCurrentTill();

  if (status === "none") {
    return (
      <LayoutLogo>
        <DialogLoading />
      </LayoutLogo>
    );
  }

  // Redirect unattended tills to their sell page
  if (status === "unattended" && till) {
    return <Navigate to={getSellRouteForTill(till)} replace />;
  }

  return (
    <div className="flex h-full flex-1 flex-col">
      <div className="h-[calc(100%-theme(spacing.20))] flex-1 px-12">
        <Outlet />
      </div>

      <Footer>
        <Link to="/home">
          <Button
            className="shadow"
            icon={faGrid2}
            variant="secondary-inverted"
          />
        </Link>

        <FooterWarning />
      </Footer>
    </div>
  );
};

const FooterWarning = () => {
  const { pathname } = useLocation();
  const { data: session } = useCurrentSession();

  if (pathname === "/settings/transactions" && !session?.isValid) {
    return (
      <Button icon={faCircleInfo} variant="info-inverted">
        <T _str="Open till in order to do refunds" />
      </Button>
    );
  }

  return null;
};
